import {Component, OnInit} from '@angular/core';
import {MatButton, MatIconButton} from "@angular/material/button";
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell, MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow, MatRowDef, MatTable
} from "@angular/material/table";
import {MatIcon} from "@angular/material/icon";
import {MatProgressSpinner} from "@angular/material/progress-spinner";
import {MatSort, MatSortHeader} from "@angular/material/sort";
import {MatTooltip} from "@angular/material/tooltip";
import {ApiService} from "../api.service";
import {DatePipe} from "@angular/common";

@Component({
  selector: 'app-anonymization',
  imports: [
    MatCell,
    MatCellDef,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderRow,
    MatHeaderRowDef,
    MatIcon,
    MatIconButton,
    MatProgressSpinner,
    MatRow,
    MatRowDef,
    MatSort,
    MatSortHeader,
    MatTable,
    DatePipe,
    MatHeaderCellDef
  ],
  templateUrl: './anonymization.component.html',
  styleUrl: './anonymization.component.css'
})
export class AnonymizationComponent implements OnInit {
  public loading: boolean = false;
  public data: any;
  public displayedColumns: string[] = ['id', 'email', 'action'];

  constructor(private api: ApiService) {
  }

  async ngOnInit() {
    await this.loadData();
  }

  async anonymize(id:any) {
    await this.api.confirmAnonymization(id);
    await this.loadData();
  }

  async loadData() {
    this.loading = true;
    this.data = await this.api.getAnonymizations();
    this.loading = false;
  }

}
